import { Tab } from '@headlessui/react';

import ModuleTabs from '@/components/common/ModuleTab';
import HistoricSearchModal from '@/components/modal/HistoricSearchModal';
import { useDisclosure } from '@/utils/hooks/useDisclosure';
import useLanguage from '@/utils/hooks/useLanguage';
import { useMemo } from 'react';
import { MdHistory } from 'react-icons/md';
import LuceraOrderBlotterTable from './LuceraOrderBlotterTable';
import TradeBlotterTable from './TradeBlotterTable';

export default function Blotters({ setCSVData }: any) {
    const lang = useLanguage();
    const [opened, handlers] = useDisclosure(false);

    const tabs = useMemo(() => {
        return [lang.blotters.orders, lang.blotters.trades];
    }, [lang]);

    return (
        <div className="w-full h-full flex flex-col">
            <HistoricSearchModal opened={opened} handlers={handlers} />
            <Tab.Group>
                <ModuleTabs.Main tabs={tabs} className="pb-2" />
                <Tab.Panels className="relative self-stretch grow basis-full p-2 overflow-hidden">
                    <Tab.Panel className="h-full">
                        <LuceraOrderBlotterTable setCSVData={setCSVData} />
                    </Tab.Panel>
                    <Tab.Panel className="h-full">
                        <TradeBlotterTable setCSVData={setCSVData} />
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
}

interface IHistoricSearch {
    handlers: {
        open: () => void;
        close: () => void;
        toggle: () => void;
    };
}

export const HistoricSearch = (props: IHistoricSearch) => {
    const { handlers } = props;

    return (
        <div
            title="Historic Search"
            className="cursor-pointer hover:bg-brand-primary p-2 rounded-sm flex items-center"
            onClick={handlers.toggle}>
            <MdHistory className="text-brand-module-title h-4 w-4" />
        </div>
    );
};
